import * as React from 'react';
import { paths } from 'config/path_helpers';
import style from './style.module.scss';
interface Props {
  writingExamples: {
    title: string;
    id: string | number;
  }[];
}
const WritingExampleIndex: React.FC<Props> = (props) => {
  return (
    <div className={style.content}>
      <h1>Writing Examples</h1>
      <p>
        This page contains <strong>real admissions essays</strong> from graduate program applicants. Each
        writing example is paired with <strong>detailed feedback</strong> from a Magoosh Admissions Expert on
        what works and what doesn't. We recommend reviewing multiple writing examples and their associated
        feedback as you prepare to write your own admissions essays.
      </p>
      <div className="section-header">
        <h3>Admissions Essays</h3>
      </div>
      <ul className={style.list}>
        {props.writingExamples.map((writingExample) => {
          return (
            <li key={writingExample.id}>
              <a href={paths.writingExample(writingExample.id)}>{writingExample.title}</a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default WritingExampleIndex;
